import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a1077f08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "select-pathway"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("h2", {
      class: "choose-pathway",
      "data-test": "pp-choose-pathway-title"
    }, "Choose a pathway")
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  class: "row pathway-tiles",
  "data-test": "pp-pathway-grid"
}
const _hoisted_4 = {
  key: 1,
  class: "row pathway-carousel expanded-tiles"
}

import { computed, ref } from "vue";
import { Carousel, Slide } from "uiv";
import { CmsPathwaysRelationship } from "../../services/cms/cms-type-definitions";
import { PathwayTileData } from "../team-outcomes/select-team-pathway.vue";
import PathwayTile from "../team-outcomes/pathway-tile.vue";
import { Analytics } from "../../services/analytics/analytics";
import cms from "../../services/cms/cms";


export default /*#__PURE__*/_defineComponent({
  __name: 'select-personal-pathway',
  props: {
    relatedPathways: {}
  },
  emits: ["display-next-button"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const activePathway = ref<PathwayTileData | null>(null);

const carouselPathways = ref<PathwayTileData[] | null>(null);

const isExpandedView = ref(false);

const controls = ref(true);

const mapToData = (p): PathwayTileData => {
  return {
    pathwayUid: p.pathway.uid,
    pathwayId: p.pathway.id,
    data: p.pathway.data,
  };
};

const handleDisplayControls = (pathwaysArr: PathwayTileData[]): void => {
  controls.value = pathwaysArr.length > 1;
};

const preparePathways = (): PathwayTileData[] => {
  return props.relatedPathways.filter((p) => p.uid !== "").map((p) => mapToData(p));
};

const pathways = computed<PathwayTileData[]>(() => {
  if (isExpandedView.value && carouselPathways.value) {
    handleDisplayControls(carouselPathways.value);
    return carouselPathways.value;
  }
  return preparePathways();
});

const currentIndex = computed<number>(() => {
  const pathwayTitle = activePathway?.value?.data.title;
  const pathwaysList = preparePathways();
  return pathwaysList.findIndex((pathway) => {
    return pathway.data.title === pathwayTitle;
  });
});

const getCarouselOrder = (): void => {
  const pathwayIndex = currentIndex;
  const pathwaysArr = preparePathways();
  const firstSection = pathwaysArr.slice(pathwayIndex.value);
  const secondSection = pathwaysArr.slice(0, pathwayIndex.value);
  carouselPathways.value = firstSection.concat(secondSection);
};

const toggleExpandedView = ({
  pathway,
  isOpen,
}: {
  pathway: PathwayTileData;
  isOpen: boolean;
}): void => {
  activePathway.value = isExpandedView.value ? null : pathway;
  getCarouselOrder();
  isExpandedView.value = isOpen;
  if (isExpandedView.value) {
    Analytics.action("Clicked Personal Pathway", "PersonalPathwayActions", {
      outcomeTitle: cms.asText(activePathway?.value?.data?.goal_relationship?.data?.full_title),
      outcomeId: activePathway?.value?.data?.goal_relationship?.id,
      outcomeUid: activePathway?.value?.data?.goal_relationship?.uid,
      pathwayTitle: cms.asText(activePathway?.value?.data.title),
      pathwayUid: activePathway?.value?.pathwayUid,
    });
  }
  emit("display-next-button", activePathway?.value?.pathwayUid);
};

return (_ctx: any,_cache: any) => {
  return (pathways.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (!isExpandedView.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pathways.value, (pathway, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "pathway-tile",
                  key: index,
                  "data-test": "pp-pathway-tiles"
                }, [
                  _createVNode(PathwayTile, {
                    "data-test": `pp-${pathway.pathwayUid}`,
                    pathway: pathway,
                    isExpandedView: isExpandedView.value,
                    onToggleExpandedView: toggleExpandedView
                  }, null, 8, ["data-test", "pathway", "isExpandedView"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(Carousel), {
                "icon-control-left": "btn btn-default-fab-chevron left",
                "icon-control-right": "btn btn-default-fab-chevron right",
                interval: 0,
                indicators: false,
                controls: controls.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pathways.value, (pathway, index) => {
                    return (_openBlock(), _createBlock(_unref(Slide), { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(PathwayTile, {
                          "data-test": `pp-${pathway.pathwayUid}-expanded`,
                          pathway: pathway,
                          isExpandedView: isExpandedView.value,
                          onToggleExpandedView: toggleExpandedView
                        }, null, 8, ["data-test", "pathway", "isExpandedView"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["controls"])
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})